import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=6102ba8a&scoped=true"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6102ba8a",
  null
  
)

export default component.exports